// Hauser MX — single scroll-reveal utility for [data-reveal] / [data-reveal-group].
// No entrance overlays, no curtains, no loading screens: instant paint, subtle settle only.
(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function revealAll() {
    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      el.classList.add('hauser-visible');
    });
  }

  if (reducedMotion.matches) {
    revealAll();
    return;
  }

  var targets = document.querySelectorAll('[data-reveal]');
  if (!targets.length) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('hauser-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  targets.forEach(function (el) {
    observer.observe(el);
  });

  reducedMotion.addEventListener('change', function (e) {
    if (e.matches) {
      observer.disconnect();
      revealAll();
    }
  });
})();
